import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateFifteenPDFSection, TemplateFifteenSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateFifteenSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText themeColor={themeColor}>{summary}</ResumePDFText>}
      </View>
    </TemplateFifteenSection>
  );
};
